<template>
  <div class="app-main-inner">
    <div style="width: fit-content">
      <div style="display: flex">
        <el-form ref="basicForm" style="display: flex;" label-position="right" label-width="100px" :disabled="viewStatus">
          <div class="section form-column" :style="$selectByLang('', 'width:320px;')">
            <el-form-item :label="$t('SeaExport.JobNo')">
              <el-input v-model="job.jobNo" no="1" :disabled="true" />
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => {
                    if (!p.statusEnabled) {
                      return false
                    }
                    return isFba ? p.fbaAir : p.airExportEnabled
                  }"
                  :default-value="job.saleProductCode || ''"
                  @parentCallBack="p => {job.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="job.fullOrInside || ''"
                  @parentCallBack="p => {job.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item :label="$t('SeaExport.Mbl2')">
              <el-checkbox v-model="job.express" style="margin-right: 2px" no="122" @change="expressChangeHandler">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
              <el-input v-if="job.express" v-model="job.mbl" no="21" style="width: 130px;" @change="mblChange" />
              <mawb-no-input v-if="!job.express" ref="mawbNoInput" v-model="job.mbl" :editable="isEditablemawbNoInput" style="width: 100%;margin-bottom: 5px" @change="mblChangeHandler" @changeCallback="mblCheckHandler(true)" />
              <el-form-item>
                <el-button no="2" type="primary" style="margin-left:1px;padding-left: 10px;padding-right: 10px;" :disabled="!selectBtnEnable" @click="selectMBLNoHandler">{{ selectMawbDialog.btnName }}</el-button>
              </el-form-item>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
              <el-input
                v-model="job.dispatchingPlace"
                no="77"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.LoadingPort') }}</span>
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="loading3Code" no="3" style="width: 60px;margin-right: 5px;" :disabled="true" />
                <cargo-advance-select
                  no="4"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="job.loadingPortCode"
                  placeholder=" "
                  style="flex:1"
                  @parentCallBack="p => {pm.loadingPortChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDestination') }}</span>
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="destination3Code" no="5" style="width:60px;margin-right: 5px;" :disabled="true" />
                <cargo-advance-select
                  no="6"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="job.destinationPortCode"
                  placeholder=" "
                  style="flex:1"
                  @parentCallBack="p => {pm.destinationPortCodeChange(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FinalPlaceOfDelivery')">
              <el-input v-model="job.destinationPlace" no="7" @input="val => {job.destinationPlace = val ? val.toUpperCase() : ''}" />
            </el-form-item>
            <el-form-item label="">
              <div style="display: flex;justify-content: space-between">
                <el-checkbox v-model="job.transfering" no="8">{{ $t('SeaExport.Transit2') }}</el-checkbox>
                <el-button no="9" type="primary" :disabled="viewStatus || (!viewStatus && !job.transfering)" @click="setTransferingHandler">{{ $t('SeaExport.EnterTransitInfo') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="10"
                  :clearable="false"
                  filterable
                  :fields="['chineseName']"
                  :select-type="selectTypeNames.local_cache_CargoSource"
                  callback-method-type="value"
                  :default-value="job.cargoSource"
                  :callback-params="{key:'cargoSource'}"
                  @parentCallBack="cargoSouceChange"
                />
              </div>
            </el-form-item>
            <!--产品服务-->
            <el-form-item :label="$t('SeaExport.ServiceProduct')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="145"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.basic_data_AirServiceProduct"
                  callback-method-type="value"
                  :default-value="job.serviceProduct"
                  :callback-params="{key:'serviceProduct'}"
                  @parentCallBack="setJobSelectValue"
                />
              </div>
            </el-form-item>
            <!--航线产品-->
            <el-form-item :label="$t('CargoMsg.Cargo_AirlineProductCode')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="airlineProductUuid"
                  filterable
                  :static-options="airlineProductDownList"
                  :method-params="{active:true}"
                  tag-value="uuid"
                  tag-name="name"
                  :filter-tag-names="['name']"
                  :static-component="new AutoComplete()"
                  callback-method-type="value"
                  :default-value="job.airlineProductUuid"
                  :callback-params="{key:'airlineProductUuid'}"
                  @parentCallBack="setJobSelectValue"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                no="11"
                filterable
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :method-params="{type:job.lob}"
                :default-value="job.customJobType"
                :static-options="customJobTypeList"
                @parentCallBack="p=>{job.customJobType=p.value;setJobSelectValue(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.AppraisalCategory')">
              <cargo-advance-select
                no="146"
                filterable
                :select-type="selectTypeNames.basic_data_AppraisalCategory"
                :default-value="job.appraisalCategory"
                placeholder=" "
                @parentCallBack="p=>{job.appraisalCategory=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="job.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="job.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DestinationAgent')">
              <cargo-advance-select
                no="12"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true, active:true}"
                :default-value="job.destinationAgent||''"
                tag-name="englishName"
                placeholder=" "
                @parentCallBack="p=>{pm.destinationAgentChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="job.cargoSource === 'NC'">
              <span slot="label" class="blue">{{ $t('SeaExport.NominatedAgent') }}</span>
              <cargo-advance-select
                no="13"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{designationAgent:true, active:true}"
                callback-method-type="value"
                :default-value="job.designationAgent||''"
                tag-name="englishName"
                :callback-params="{key:'designationAgent'}"
                :disabled="!designationAgentEnabled"
                placeholder=" "
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-company-select
                no="exChangeAgent"
                :disabled="!job.dischargingPortDoor"
                :method-params="{bookingAgent:true,active:true}"
                :default-value="job.exChangeAgent||''"
                @change="onExChangeAgentChange"
              />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="14"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true, active: true}"
                callback-method-type="value"
                :default-value="job.bookingAgent||''"
                :callback-params="{key:'bookingAgent'}"
                :disabled="!bookingAgentEnabled"
                placeholder=" "
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocCutOffDate')">
              <el-date-picker
                ref="fileCutoff"
                v-model="job.fileCutoff"
                no="15"
                type="datetime"
                style="width:100%;"
                clearable
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                @blur="()=> { handleBlur('fileCutoff', null, true, false, job) }"
              />
            </el-form-item>
            <el-form-item v-if="!isFba" :label="$t('SeaExport.ActualDateOfDeparture')">
              <el-date-picker
                v-model="job.atd"
                no="16"
                type="date"
                style="width:100%;"
                clearable
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" class="custom">
              <cargo-rich-textarea
                v-model="job.cargoEnglishName"
                no="17"
                :disabled="viewStatus"
                :text-chars="0"
                :warning-count="45"
                :auto-uppercase="isUppercaseByConfig"
                :class="job.cargoEnglishNameWarning === 1 ? 'red-border' : ''"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{pm.cargoEnglishNameChangeHandler(val)},true,null,isUppercaseByConfig , {
                  warningCount: englishNameWarningCount,
                  maxChar: englishNameMaxChars
                })"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')" class="custom">
              <cargo-rich-textarea
                v-model="job.cargoChineseName"
                no="49"
                :disabled="viewStatus"
                :text-chars="0"
                :warning-count="45"
                :class="job.cargoChineseNameWarning === 1 ? 'red-border' : ''"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val},true,null,true , {
                  warningCount: englishNameWarningCount,
                  maxChar: englishNameMaxChars
                })"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WoodOrNotWood')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="147"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.local_cache_AirExportConstants$WOOD"
                  :default-value="job.wood"
                  :fields="['chineseName']"
                  @parentCallBack="onWoodOrNotWoodChagne"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HazardousGoodsOption')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="148"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.local_cache_AirExportConstants$HAZARDOUS_GOODS_OPTION"
                  :default-value="job.hazardousGoodsOption"
                  :fields="['chineseName']"
                  @parentCallBack="onHazardousGoodsOptionChagne"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.handlingInformation')">
              <el-input
                v-model="job.handlingInformation"
                no="149"
                :readonly="true"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.handlingInformation'),job.handlingInformation,val=>{job.handlingInformation=val})"
              />
            </el-form-item>
          </div>
          <div class="section form-column" :style="$selectByLang('width:550px;', 'width:630px;')">

            <div>
              <!-- 集装器 -->
              <booking-air-uld-data-grid
                :value="airUlds"
                :is-edit="!viewStatus"
                :job="job"
                style="width: 100%"
              />
              <el-form-item label="" class="auto-width" label-width="120px">
                <div style="display: flex;justify-content: space-between">
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Quantity') }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Weight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Cubage') }}{{ openImperial ? 'CFT' : 'CBM' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('queryJob.Density') }}kg/m³</div>
                </div>
              </el-form-item>
              <div style="display: flex">
                <div style="display: flex;align-items: center;text-align: right; min-width: 120px;">
                  <div style="width: 100%;padding-right: 10px">
                    <i class="el-icon-question" :title="setDimensionsTitle(job.commissionDimensions)" />
                    <span>{{ $t('SeaExport.Consignation') }} </span>
                  </div>
                </div>
                <el-form-item class="auto-width" label-width="0px">
                  <div style="display: flex;justify-content: space-between">
                    <auto-number-input
                      v-model="job.quantityContract"
                      no="18"
                      :precision="0"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.weightContractImperial"
                      no="weightContractImperial"
                      :precision="2"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.cubAgeContractImperial"
                      no="cubAgeContractImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.chargeWeightImperial"
                      no="chargeWeightImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.weightContract"
                      no="19"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="weightContractChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.cubageContract"
                      no="20"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="cubageContractChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.chargeWeight"
                      no="21"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-model="job.densityContract"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      no="78"
                    />
                  </div>
                </el-form-item>
              </div>
              <div style="display: flex">
                <div style="display: flex;align-items: center;text-align: right; min-width: 120px;">
                  <div style="width: 100%;padding-right: 10px">
                    <i class="el-icon-question" :title="setDimensionsTitle(measurements)" />
                    <span>{{ $t('SeaExport.Booking') }} </span>
                  </div>
                </div>
                <el-form-item class="auto-width" label-width="0px">
                  <div style="display: flex;justify-content: space-between">
                    <auto-number-input
                      v-model="job.quantityBooking"
                      no="22"
                      :precision="0"
                      :min="0"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.weightBookingImperial"
                      no="weightBookingImperial"
                      :precision="2"
                      :min="0"
                      @change="pm.weightCubAgeImperialChangeHandler('weightBooking')"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.cubAgeBookingImperial"
                      no="cubAgeBookingImperial"
                      :precision="3"
                      :min="0"
                      @change="pm.weightCubAgeImperialChangeHandler('cubageBooking')"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.chargeWeightBookingImperial"
                      no="chargeWeightBookingImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.weightBooking"
                      no="23"
                      :precision="3"
                      :min="0"
                      @change="pm.doWeightCubAgeChangeHandler('weightBooking')"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.cubageBooking"
                      no="24"
                      :precision="3"
                      :min="0"
                      @change="pm.doWeightCubAgeChangeHandler('cubageBooking')"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.chargeWeightBooking"
                      no="25"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-model="job.densityBooking"
                      :precision="3"
                      :min="0"
                      no="79"
                    />
                  </div>
                </el-form-item>
              </div>
              <div style="display: flex">
                <div style="display: flex;align-items: center;text-align: right; min-width: 120px;">
                  <div style="width: 100%;padding-right: 10px">
                    <i class="el-icon-question" :title="setDimensionsTitle(job.dimensionsActual)" />
                    <span>{{ $t('SeaExport.FrontCabinActual') }} </span>
                  </div>
                </div>
                <el-form-item class="auto-width" label-width="0px">
                  <div style="display: flex;justify-content: space-between">
                    <auto-number-input
                      v-model="job.quantityActual"
                      no="26"
                      :precision="0"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.weightActualImperial"
                      no="weightActualImperial"
                      :precision="2"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.cubAgeActualImperial"
                      no="cubAgeActualImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.cWeightImperial"
                      no="cWeightImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.weightActual"
                      no="27"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="weightActualChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.cubageActual"
                      no="28"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="cubageActualChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.cWeight"
                      no="29"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="pm.weightCubageChangeHandler('chargeWeightActual')"
                    />
                    <auto-number-input
                      v-model="job.densityActual"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      no="80"
                    />
                  </div>
                </el-form-item>
              </div>
              <div style="display: flex">
                <div style="display: flex;align-items: center;text-align: right; min-width: 120px;">
                  <div style="width: 100%;padding-right: 10px">
                    <i class="el-icon-question" :title="setDimensionsTitle(job.freightStationDimensions)" />
                    <span>{{ $t('SeaExport.FreightStation') }} </span>
                  </div>
                </div>
                <el-form-item class="auto-width" label-width="0px">
                  <div style="display: flex;justify-content: space-between">
                    <auto-number-input
                      v-model="job.quantityStation"
                      no="86"
                      :precision="0"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.weightStationImperial"
                      no="weightStationImperial"
                      :precision="2"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.cubAgeStationImperial"
                      no="cubAgeStationImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.chargeWeightStationImperial"
                      no="chargeWeightStationImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.weightStation"
                      no="87"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="weightStationChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.cubageStation"
                      no="88"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="cubageStationChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.chargeWeightStation"
                      no="89"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-model="job.densityStation"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      no="90"
                    />
                  </div>
                </el-form-item>
              </div>
              <div style="display: flex">
                <div style="display: flex;align-items: center;text-align: right; min-width: 120px;">
                  <div style="width: 100%;padding-right: 10px">
                    <i class="el-icon-question" :title="setDimensionsTitle(job.docDimensions)" />
                    <span>{{ $t('SeaExport.Documentation') }} </span>
                  </div>
                </div>
                <el-form-item class="auto-width" label-width="0px">
                  <div style="display: flex;justify-content: space-between">
                    <auto-number-input
                      v-model="cargoDoc.quantity"
                      no="30"
                      :precision="0"
                      :min="0"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="cargoDoc.weightImperial"
                      no="weightImperial"
                      :precision="2"
                      :min="0"
                      @change="pm.weightCubAgeImperialChangeHandler('weight')"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="cargoDoc.cubAgeImperial"
                      no="cubAgeImperial"
                      :precision="3"
                      :min="0"
                      @change="pm.weightCubAgeImperialChangeHandler('cubage')"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="cargoDoc.chargeWeightImperial"
                      no="chargeWeightImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="cargoDoc.weight"
                      no="31"
                      :precision="3"
                      :min="0"
                      @change="pm.doWeightCubAgeChangeHandler('weight')"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="cargoDoc.cubage"
                      no="32"
                      :precision="3"
                      :min="0"
                      @change="pm.doWeightCubAgeChangeHandler('cubage')"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="cargoDoc.cWeight"
                      no="33"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-model="job.densityDoc"
                      :precision="3"
                      :min="0"
                      no="81"
                    />
                  </div>
                </el-form-item>
              </div>

              <div style="display: flex">
                <div style="display: flex;align-items: center;text-align: right; min-width: 120px;">
                  <div style="width: 100%;padding-right: 10px">
                    <i class="el-icon-question" :title="setDimensionsTitle(job.dimensionsSigning)" />
                    <span>{{ $t('SeaExport.SignBill') }} </span>
                  </div>
                </div>
                <el-form-item class="auto-width" label-width="0px">
                  <div style="display: flex;justify-content: space-between">
                    <auto-number-input
                      v-model="job.quantitySigning"
                      no="91"
                      :precision="0"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.weightSigningImperial"
                      no="weightSigningImperial"
                      :precision="2"
                      :min="0"
                      :disabled="true"
                      @change="weightSigningChange"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.cubAgeSigningImperial"
                      no="cubAgeSigningImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="cubageSigningChange"
                    />
                    <auto-number-input
                      v-show="openImperial"
                      v-model="job.chargeWeightSigningImperial"
                      no="chargeWeightSigningImperial"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.weightSigning"
                      no="92"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="weightSigningChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.cubageSigning"
                      no="93"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      @change="cubageSigningChange"
                    />
                    <auto-number-input
                      v-show="!openImperial"
                      v-model="job.chargeWeightSigning"
                      no="94"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                    />
                    <auto-number-input
                      v-model="job.densitySigning"
                      :precision="3"
                      :min="0"
                      :disabled="true"
                      no="95"
                    />
                  </div>
                </el-form-item>
              </div>

            </div>
            <div style="display: flex;">
              <div style="margin-right: 5px;flex-grow: 1">
                <el-form-item :label="$t('SeaExport.Slac')" label-width="120px">
                  <el-input-number v-model="job.slac" no="slac" style="width: 100%" :min="0" :precision="0" :controls="false" @change="p=>{pm.slacChangeHandler(p)}" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.AirlineCompany')" label-width="120px">
                  <cargo-advance-select
                    no="34"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{airCmp:true, active:true}"
                    :default-value="job.carrierId || ''"
                    :disabled="!carrierIdEnabled"
                    :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
                    :fields="['shortName', 'chineseName']"
                    placeholder=" "
                    @parentCallBack="p => {pm.carrierChangeHandler(p.value||0);pm.airlineCompanyChange(p.value||0);airlineCompanyCheckHandler(p.value||0)}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Flight')" label-width="120px">
                  <el-input v-model="job.voyageFlight" no="35" @change="voyageFlightCheckHandler" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.OperationDate')" label-width="120px">
                  <el-date-picker
                    v-model="job.customsDate"
                    no="36"
                    value-format="yyyy-MM-dd"
                    type="date"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
                <el-form-item label-width="120px">
                  <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
                  <div style="display: flex">
                    <el-date-picker
                      ref="etd"
                      :value="job.etd"
                      :disabled="provisionEtdLocked"
                      no="37"
                      clearable
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm"
                      format="yyyy-MM-dd HH:mm"
                      style="flex: 1; width:140px; margin-right: 5px"
                      @input="etdChange"
                      @blur="()=> { handleBlur('etd', etdChange, false, false, job) }"
                    />
                    <span>{{ job.sailingDay|filterWeek }}</span>
                  </div>
                  <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
                </el-form-item>
                <el-form-item label-width="120px">
                  <span slot="label">{{ $t('SeaExport.DateOfArrival2') }}</span>
                  <div style="display: flex">
                    <el-date-picker
                      ref="eta"
                      v-model="job.eta"
                      no="38"
                      style="flex: 1; width:140px; margin-right: 5px"
                      type="datetime"
                      clearable
                      value-format="yyyy-MM-dd HH:mm"
                      format="yyyy-MM-dd HH:mm"
                      @input="etaChange"
                      @blur="()=> { handleBlur('eta', etaChange, false, false, job) }"
                    />
                    <span>{{ job.etaSailingDay|filterWeek }}</span>
                  </div>
                </el-form-item>
                <el-form-item label-width="120px">
                  <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
                  <div style="display: flex">
                    <el-date-picker
                      ref="atd"
                      :value="job.atd"
                      no="39"
                      :disabled="viewStatus"
                      style="flex: 1; width:140px; margin-right: 5px"
                      type="datetime"
                      clearable
                      value-format="yyyy-MM-dd HH:mm"
                      format="yyyy-MM-dd HH:mm"
                      @input="atdChange"
                      @blur="()=> { handleBlur('atd', atdChange, false, false, job) }"
                    />
                    <span>{{ job.atdSailingDay|filterWeek }}</span>
                  </div>
                </el-form-item>
                <el-form-item label-width="120px">
                  <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
                  <div style="display: flex">
                    <el-date-picker
                      ref="ata"
                      v-model="job.ata"
                      no="40"
                      :disabled="viewStatus"
                      style="flex: 1; width:140px; margin-right: 5px"
                      type="datetime"
                      clearable
                      value-format="yyyy-MM-dd HH:mm"
                      format="yyyy-MM-dd HH:mm"
                      @input="ataChange"
                      @blur="()=> { handleBlur('ata', ataChange, false, false, job) }"
                    />
                    <span>{{ job.ataSailingDay|filterWeek }}</span>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Marks')" label-width="120px">
                  <cargo-rich-textarea
                    v-model="job.mark"
                    no="41"
                    :disabled="viewStatus"
                    :text-chars="0"
                    :warning-count="45"
                    :auto-uppercase="isUppercaseByConfig"
                    style="height: 110px;"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{pm.markChangeHandler(val)},true,null,isUppercaseByConfig , {
                      warningCount: englishNameWarningCount,
                      maxChar: englishNameMaxChars
                    })"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CategoryOfGoods')" label-width="120px">
                  <cargo-advance-select
                    no="42"
                    :select-type="selectTypeNames.basic_data_CargoInformation"
                    filterable
                    :callback-params="{key:'cargoCode'}"
                    :default-value="job.cargoCode"
                    placeholder=" "
                    @parentCallBack="txtCargoInformationChangeHandler"
                  />
                  <el-input v-model="job.cargoName" :disabled="!job.cargoCode" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')" label-width="120px">
                  <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_TransportSource"
                    no="transportSource"
                    :default-value="job.transportSource"
                    :cache="false"
                    tag-value="code"
                    placeholder=" "
                    @parentCallBack="item=>job.transportSource=item.value"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')" label-width="120px">
                  <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_StatisticArea"
                    no="statisticArea"
                    :default-value="job.statisticArea"
                    :cache="false"
                    tag-value="code"
                    placeholder=" "
                    @parentCallBack="item=>job.statisticArea=item.value"
                  />
                </el-form-item>
              </div>
              <div style="flex-grow: 1">
                <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
                  <cargo-advance-select
                    no="43"
                    filterable
                    :clearable="false"
                    :select-type="selectTypeNames.basic_data_PaymentTerm"
                    :default-value="job.paymentTermMBL || ''"
                    @parentCallBack="p => pm.paymentTermMBLChangeHandler(p)"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.BookingProperty')">
                  <cargo-advance-select
                    no="44"
                    filterable
                    :clearable="false"
                    :select-type="selectTypeNames.local_cache_BookingTerm"
                    :default-value="job.bookingTerm"
                    :fields="['chineseName']"
                    @parentCallBack="p => {pm.bookingTermChangeHandler(p)}"
                  />
                </el-form-item>
                <el-form-item v-if="isAeBooking" :label="$t('SeaExport.PortOfDestinationServices')">
                  <el-checkbox
                    v-model="job.dischargingPortDoor"
                    no="dischargingPortDoor"
                    style="display: block;"
                    @change="syncSlaves('dischargingPortDoor')"
                  >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
                  </el-checkbox>
                  <el-checkbox
                    v-model="job.usCustomsClearance"
                    no="usCustomsClearance"
                    style="display: block;"
                    @change="syncSlaves('usCustomsClearance')"
                  >{{ $t('queryJob.UsCustomsClearance') }}
                  </el-checkbox>
                  <el-checkbox
                    v-model="job.destPortCustomsClearance"
                    no="destPortCustomsClearance"
                    style="display: block;"
                  >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
                  </el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CargoType')">
                  <cargo-advance-select
                    no="45"
                    filterable
                    :clearable="false"
                    :select-type="selectTypeNames.basic_data_CargoType"
                    callback-method-type="value"
                    :default-value="job.cargoType"
                    :callback-params="{key:'cargoType'}"
                    @parentCallBack="onCargoTypeChagne"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.OrderChannels')">
                  <el-input
                    v-model="job.salesChannel"
                    :disabled="true"
                    no="82"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsignationRelationNumber')">
                  <el-input
                    v-model="job.trustFromJob"
                    :disabled="true"
                    no="trustFromJob"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
                  <el-input
                    v-model="job.relatedJob"
                    :disabled="true"
                    no="relatedJob"
                  />
                </el-form-item>
                <el-form-item v-if="showChannelNo" :label="$t('SeaExport.ChannelNo')">
                  <el-input v-model="job.channelNo" :disabled="true" no="83" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Package')">
                  <!-- <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_Packing"
                    callback-method-type="value"
                    :default-value="job.packing"
                    tag-name="chineseName"
                    :callback-params="{key:'packing'}"
                    @parentCallBack="setJobSelectValue"
                  /> -->
                  <cargo-packing-select
                    no="46"
                    :default-value="job.packing"
                    :callback-params="{}"
                    placeholder=" "
                    @change="p => {p.key = 'packing';setJobSelectValue(p)}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CargoSize')">
                  <el-input v-model="measurements" no="47" type="textarea" :rows="5" :disabled="true" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Remarks')">
                  <el-input
                    v-model="job.remarks"
                    no="48"
                    type="textarea"
                    :rows="5"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('CargoMsg.Cargo_FrontEndWarehouseOperation')">
              <cargo-advance-select
                no="frontEndWarehouseOperation"
                :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                :method-params="{dataType:1, deletionFlag: false}"
                filterable
                :clearable="true"
                :default-value="job.frontEndWarehouseOperation"
                @parentCallBack="p=>{job.frontEndWarehouseOperation=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CargoTerminalOperation')">
              <cargo-advance-select
                no="cargoTerminalOperation"
                :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                :method-params="{dataType:0, deletionFlag: false}"
                filterable
                :clearable="true"
                :default-value="job.cargoTerminalOperation"
                @parentCallBack="cargoTerminalOperationChange"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EstimatedDeliveryDate')">
              <el-date-picker v-model="job.estimatedDeliveryDate" :disabled="!isEdit || !job.cargoTerminalOperation" style="flex: 1; width:200px; margin-right: 5px" no="estimatedDeliveryDate" type="date" value-format="yyyy-MM-dd" clearable />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')">
              <cargo-input v-model="job.customerRefNo" no="76" :trim="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="50"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="job.tradeTerm"
                :callback-params="{key:'tradeTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(job.dcOffice)"
                @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                ref="dc"
                no="51"
                :method-params="{category:'role',shape:'doc'}"
                :default-value="job.dc||''"
                placeholder=" "
                :static-options="userPortRoleData.doc"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(job.plannerOffice)"
                @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-user-select
                no="52"
                :method-params="{officeId:job.opOffice,category:'role',shape:'airline'}"
                :default-value="job.planner||''"
                placeholder=" "
                :static-options="userPortRoleData.airline"
                @change="p=>{pm.plannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                no="53"
                :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="54"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                placeholder=" "
                @change="p=>{job.cargoSalesId = p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesCompany')">
              <el-input v-model="txtSalesOffice" no="55" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesDepartment')">
              <cargo-department-new-select
                no="56"
                :disabled="!job.sales"
                :enables="true"
                :sales-id="Number(job.sales)"
                :office-id="job.salesOffice"
                :department-id="Number(job.salesDepartment)"
                @change="p=>{pm.salesDepartmentChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Sales')">
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  no="57"
                  :disabled="!saleEnabled"
                  :method-params="{officeId:pm.salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales',active:true}"
                  :default-value="job.sales||''"
                  :static-options="salesList"
                  :placeholder="salesPrompt||' '"
                  style="width: 130px;flex: 1"
                  @change="p=>{pm.salesChangeHandler(p);}"
                />&nbsp;
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                no="58"
                :disabled="opOfficeDisabled"
                :office-id="Number(job.opOffice)"
                placeholder=" "
                :is-regional-commission="isRegionalCommission"
                @change="p=>{pm.opOfficeChargeHandler(p);}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                no="59"
                :office-id="Number(job.opOffice)"
                :enables="true"
                :department-id="Number(job.opDepartment)"
                placeholder=" "
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select
                no="60"
                :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
                :default-value="job.op||''"
                placeholder=" "
                :static-options="userPortRoleData.op"
                @change="p=>{pm.opChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(job.csrOffice)"
                @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="61"
                :method-params="{category:'role',shape:'csr'}"
                :default-value="job.csr||''"
                placeholder=" "
                :static-options="userPortRoleData.csr"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole1"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole2"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
          </div>

          <!-- FBA相关信息-->
          <div v-if="isFba" class="section form-column">
            <el-form :disabled="viewStatus" label-width="120px" label-position="right">
              <el-form-item :label="$t('AirExport.ServiceChannel')">
                <el-input v-model="fbaJob.serviceChannel" no="serviceChannel" />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('AirExport.EstimatedStorageGoodArrivalTime') }}</span>
                <el-date-picker
                  v-model="fbaJob.preWarehousingTime"
                  no="preWarehousingTime"
                  type="datetime"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
                <div style="display: flex; flex: 1;">
                  <el-tooltip :content="fbaJob.warehouseCode" placement="bottom-end">
                    <el-cascader
                      v-model="fbaJob.warehouseCode"
                      style="padding-right: 2px;"
                      :options="destinations"
                      filterable
                      :clearable="true"
                      no="84"
                      @focus="JobUtils.focusWarehouseCode(fbaJob)"
                      @blur="JobUtils.blurWarehouseCode(fbaJob)"
                      @change="p=>{JobUtils.warehouseCodeHandler(fbaJob, p);}"
                    />
                  </el-tooltip>
                  <el-checkbox v-model="fbaJob.remoteWarehouse" no="remoteWarehouse">{{ $t('AirExport.RemoteWarehouse') }}</el-checkbox>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Warehouse.DestinationCountry')">
                <el-input v-model="fbaJob.country" :disabled="true" no="country" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.ZipCode')">
                <el-input v-model="fbaJob.zipCode" :disabled="true" no="zipCode" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.DestinationDeliveryMethod')">
                <cargo-advance-select
                  no="destinationDistribution"
                  :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"
                  filterable
                  :clearable="false"
                  :default-value="fbaJob.destinationDistribution"
                  @parentCallBack="p=>{fbaJob.destinationDistribution=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierCompany')">
                <el-select v-model="fbaJob.expressCompany" no="expressCompany" placeholder="" clearable>
                  <el-option
                    v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierNumber')">
                <el-input v-model="fbaJob.expressNo" no="expressNo" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.DomesticWarehouse')">
                <cargo-company-select
                  no="warehouseCmp"
                  :method-params="{warehouse:true,active:true}"
                  :default-value="Number(fbaJob.domesticWarehouse)||''"
                  :placeholder="$t('SeaExport.PleaseSelectWarehouse')"
                  @change="p=>{fbaJob.domesticWarehouse=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.ForeignWarehouse')">
                <cargo-advance-select
                  no="overseaWarehouseCode"
                  :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                  filterable
                  :method-params="{ifFba:false}"
                  :clearable="false"
                  tag-name="countryChineseName"
                  tag-value="warehouseCode"
                  :default-value="job.overseaWarehouseCode"
                  style="width:100%;"
                  @parentCallBack="p=>{job.overseaWarehouseCode=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.CustomsDeclarationMethod')">
                <cargo-advance-select
                  no="customsMethodPol"
                  :select-type="selectTypeNames.basic_data_CustomsMode"
                  :method-params="{serviceType:0}"
                  filterable
                  :clearable="false"
                  :default-value="fbaJob.customsMethodPol"
                  @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
                <cargo-advance-select
                  no="customsDeclarationType"
                  :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                  filterable
                  :default-value="job.customsDeclarationType||''"
                  :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                  @parentCallBack="p=>{job.customsDeclarationType=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.CustomsClearanceMethod')">
                <cargo-advance-select
                  no="customsMethodPod"
                  :select-type="selectTypeNames.basic_data_CustomsMode"
                  :method-params="{serviceType:1}"
                  filterable
                  :clearable="false"
                  :default-value="fbaJob.customsMethodPod"
                  @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
                />
              </el-form-item>

              <hr style="margin-top: 20px;margin-bottom: 20px;">
              <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
              <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="job.estWarehouseDeliveryTime"
                  no="estWarehouseDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="job.actWarehouseDeliveryTime"
                  no="actWarehouseDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="job.estGoodsDeliveryTime"
                  no="estGoodsDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="job.actGoodsDeliveryTime"
                  no="actGoodsDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.EstimatedDeliveryTime')">
                <el-date-picker
                  v-model="job.estDeliveryTime"
                  no="estDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.ActualDeliveryTime')">
                <el-date-picker
                  v-model="job.actDeliveryTime"
                  no="actDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">

            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="job.userDefinedField1"
                no="62"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="job.userDefinedField2"
                no="63"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="job.userDefinedField3"
                no="64"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="job.userDefinedField4"
                no="65"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="job.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </div>

        </el-form>
      </div>
      <div class="section">
        <div class="form-row">
          <span class="title">{{ $t('SeaExport.TicketsInfo') }}</span>
          <div style="display:flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px">
            <span>{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ job.lclSlaves ? job.lclSlaves.length : 0 }}</span>
            <div v-if="viewStatus && viewSource === 'bookingWorkspace'" v-show="cooperateEdit" class="triggers">
              <el-button no="66" type="primary" @click="newSubJobHandler">{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button no="67" type="primary" :disabled="!selectedRow" @click="editSubJobHandler">{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button no="68" type="primary" :disabled="Number(job.operateType) !== 0" @click="attachSubJobHandler">{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button no="69" type="danger" :disabled="!selectedRow || viewSource === 'financeDetail'" @click="detachSubJobHandler">{{ $t('SeaExport.RemoveTickets') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <cargo-ag-grid
              config-module="150006"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="height:350px"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>

        </div>
      </div>
    </div>
    <!--输入中转信息-->
    <transit-port-dialog :visible.sync="transitPortDialog.visible" :job="job" @enter="transitPortEnterHandler" />
    <!--选择主单-->
    <select-mawb-dialog :visible.sync="selectMawbDialog.visible" :carrier-id="selectMawbDialog.carrierId" :type="selectMawbDialog.type" :operate-type="selectMawbDialog.operateType" @enterEvent="selectedMAWBHandler" />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="70"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="showDialog"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.isUppercase"
        style="height: 320px;"
        no="85"
      />
      <span slot="footer">
        <el-button v-show="!viewStatus" no="71" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="71_1"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="72"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" no="73" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="74" type="primary" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="75" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--加入小票弹窗-->
    <query-ae-lcl-dialog
      :visible.sync="queryAeLclDialog.visible"
      :job="job"
      @attachSubJobCallBackHandler="attachSubJobCallBackHandler"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabMasterHP } from './tabMasterHP'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import SelectMawbDialog from './components/SelectMAWBDialog'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import TransitPortDialog from './components/TransitPortDialog'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { detch, batchAddJob, unbindingNew } from '@/api/AirExport/airExportJob'
import { IataPrice } from '@/class/model/sys/IataPrice'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { ErrorTip } from '@/utils/class/ErrorTip'
import queryAeLclDialog from '@/components/Cargo/Job/queryAeLclDialog'
import DateUtils from '@/utils/dateUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import mawbNoInput from '@/components/Cargo/Job/mawbNoInput'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import StrUtils from '@/utils/StrUtils'
import { multiply, mergeArray, dateCompare, handleBlur } from '@/utils/commonUtil'
import { checkJobForShared } from '@/api/seaExport/seaExportJob'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import lang from '@/lang'
import { FbaJob } from '@/class/model/booking/FbaJob'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import { Company } from '@/class/model/mdm/Company'
import { getAirlineList } from '@/api/partner/airline'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import BookingAirUldDataGrid
  from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/bookingAirUldDataGrid'
import { UnitLoadDeviceUtil } from '@/class/cargo/model/utils/UnitLoadDeviceUtil'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import {
  EXPORT_CONTROLLED_PRODUCT,
  LOG_AE_AIR_BOOKING,
  RATE_TYPE,
  TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { AutoComplete } from '@/utils/class/AdvanceSelect'

export default {
  name: 'TabMaster',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE': return lang.t('SeaExport.TUE')
        case 'WED': return lang.t('SeaExport.WED')
        case 'THU': return lang.t('SeaExport.THU')
        case 'FRI': return lang.t('SeaExport.FRI')
        case 'SAT': return lang.t('SeaExport.SAT')
        case 'SUN': return lang.t('Pricing.Sun')
        case 'MON':
        default: return lang.t('SeaExport.MON')
      }
    }
  },
  components: { cargoInput, BookingAirUldDataGrid, cargoAdvanceSelect, AutoNumberInput, cargoPackingSelect, cargoDepartmentSelect, SelectMawbDialog, TransitPortDialog, cargoUserSelect, cargoOfficeSelect, cargoDepartmentNewSelect, cargoRichTextarea, queryAeLclDialog, mawbNoInput, cargoCompanySelect },
  mixins: [SenderAndReceiver, BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    isFba: { // 是否是FBA业务
      type: Boolean,
      default: false
    },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      handleBlur, AutoComplete,
      airUlds: [],
      pm: new TabMasterHP(this),
      isZh: this.$store.getters.language === 'zh',
      selectTypeNames: TYPE_NAMES,
      TAX_NATURES,
      EXPORT_CONTROLLED_PRODUCT,
      rateType: RATE_TYPE,
      salesCanSeeBookingAgent: false,
      selectMawbDialog: {
        btnName: this.$t('SeaExport.PleaseSelect'),
        visible: false,
        type: '',
        carrierId: 0,
        operateType: -1
      },
      transitPortDialog: {
        visible: false
      },
      loading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          this.onRowDataChanged(event)
        },
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        onSelectionChanged: event => {
          // 触发多选
          this.onMultipleSelected(event)
        },
        onCellDoubleClicked: event => {
          this.btnLcLEditClickHandler(event)
        },
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      optStatusDefs: {
        edit: 'edit', // edit
        view: 'view' // 查看
      },
      // openImperial: false, // 是否开启英制单位
      job: new AirExportJob().fillDefaultValue().getData(),
      handlingInformationCode: '',
      currentOptStatus: 'view',
      officeList: [],
      cargoDoc: new AirCargoDoc().fillDefaultValue().getData(),
      showImperialButton: false, // 英制单位显示按钮
      isOpenImperial: false, // 是否开启英制单位
      originalImperial: false, // 是否开启英制单位
      measurements: '', // 货物尺寸
      txtSalesOffice: '', // 销售所在分公司
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        },
        hasHandlingInformation: false
      },
      salesList: null, // 销售数据源
      salesPrompt: '', // 销售悬浮提示
      selectBtnEnable: false,
      mblEnable: false,
      selectedMAWB: null,
      hasTask: false,
      iataPrice: new IataPrice().fillDefaultValue().getData(),
      mawbinfoDatas: null,
      selectedRowIndex: -1,
      ticketDialog: {
        visible: false,
        value: 0
      },
      queryAeLclDialog: {
        visible: false
      },
      loading3Code: '', // 装货港三字码
      destination3Code: '', // 目的港三字码
      rowData: [],
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      fbaJob: new FbaJob().fillDefaultValue().getData(), // fbaJob
      FbaJobConstants,
      JobUtils,
      oldMbl: '',
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      showMarkOrCargoEnglishNameDialog: false,
      markChange: false,
      cargoEnglishNameChange: false,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      oldMark: '',
      oldCargoEnglishName: '',
      isZY: false, // 显示中邮选项
      editMawblNoMode: 0, // CARGO-46018 新增配置项
      AirExportConstants,
      airlineProductDownList: [], // 航线产品 下拉
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    provisionEtdLocked() {
      return !!(this.provisionLock && this.provisionLock.etdLocked)
    },
    openImperial() {
      if (this.viewStatus) {
        return this.isOpenImperial
      } else {
        return this.originalImperial
      }
    },
    // 是否为空运订舱页面
    isAeBooking() {
      return this.$route.path.toLowerCase() === '/AirExport/AeBooking'.toLowerCase()
    },
    columnDefs() {
      return [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.JobNo'),
          field: 'jobNo',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 120,
          hide: true
        }, {
          headerName: this.$t('Warehouse.WarehouseInState'),
          colId: 'warehouseStatus',
          field: 'warehouseStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', Number(params.value), 'chineseName')
          },
          hide: true
        }, {
          headerName: 'HAWB',
          field: 'hblNbr2',
          width: 120

        },
        {
          headerName: this.$t('SeaExport.LoadingPort'),
          field: 'loadingPortCode',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'destinationPortCode',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          field: 'quantityContract',
          width: 120,
          cellRenderer: (params) => {
            return !params.value ? 0 : formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          field: 'weightContract',
          width: 120,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          field: 'cubageContract',
          width: 120,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.CommissionedChargedWeight'),
          field: 'chargeWeight',
          width: 150,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          width: 120,
          cellRenderer: (params) => {
            return !params.value ? 0 : formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          width: 120,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          width: 120,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.ActualChargedWeight'),
          field: 'cWeight',
          width: 150,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3))
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Shipper'),
          colId: 'shipperLine1',
          field: 'shipperLine1',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          hide: true,
          width: 120
        }
      ]
    },
    config() {
      return this.context.config
    },
    viewStatus() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    showDialog() {
      // 判断 如果是handleInformation 弹框不可操作
      if (this.advanceTextDialog.hasHandlingInformation) {
        return true
      }
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    editStatus() {
      return this.optStatusDefs.edit === this.currentOptStatus
    },
    designationAgentEnabled() {
      return !this.viewStatus && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'designationAgent')
    },
    bookingAgentEnabled() {
      return !this.viewStatus && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'bookingAgent')
    },
    carrierIdEnabled() {
      return !this.viewStatus && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'carrierId')
    },
    saleEnabled() {
      return !this.viewStatus && this.pm.canChangeSalesOfJob
    },
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination()
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    showChannelNo() {
      return ['B2B', this.$t('Menu.WallTechFamily')].includes(this.job.salesChannel)
    },
    location() {
      if (!this.job.fba) {
        return LOG_AE_AIR_BOOKING.code
      }
      return ''
    },
    isCopy() {
      return this.action === 'copy'
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    },
    /**
     * CARGO-46018 友邦：空运订舱中主单号只能通过主单管理维护的单号进行选择
     * 0–自由编辑，可手动输入也可选择主单号列表
     * 1–友邦模式，当订舱性质=自订舱时，输入框置灰，只能通过选择列表主单号。否则可自由编辑，可手动也可列表选择
     */
    isEditablemawbNoInput() {
      return !(this.mblEnable && (this.editMawblNoMode === 0 || !(this.editMawblNoMode === 1 && this.job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code)))
    }
  },
  watch: {
    'advanceTextDialog.visible': {
      handler(newVal) {
        if (this.action !== 'look' && newVal) {
          const title = this.advanceTextDialog.title
          if (title === this.$t('SeaExport.EnglishDescriptionOfGoods') || title === this.$t('SeaExport.Marks')) {
            this.showMarkOrCargoEnglishNameDialog = true
          }
        }
      }
    }
  },
  async created() {
    await this.pm.init()
    this.markChange = false
    this.cargoEnglishNameChange = false
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
  },
  beforeMount() {
  },
  methods: {
    txtCargoInformationChangeHandler(obj) {
      this.setJobSelectValue(obj)
      this.job.cargoName = obj.englishName || ''
    },
    setTransferingHandler() {
      this.transitPortDialog.visible = true
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    expressChangeHandler() {
      if (!this.job.express) {
        this.job.mbl = ''
        this.selectBtnEnable = true
      }
    },
    selectMBLNoHandler() {
      if (this.selectMawbDialog.btnName === this.$t('SeaExport.PleaseSelect')) {
        this.selectMawbDialog.type = this.job.bookingTerm === 'DB' ? 'input' : 'new'
        this.selectMawbDialog.carrierId = this.job.carrierId
        this.selectMawbDialog.visible = true
      } else if (this.job.bookingTerm === BookingTerm.DB_BOOKING_TYPE.code) {
        this.job.mbl = ''
        this.pm.checkButtonSate()
      } else {
        detch({ jobKey: this.job.uuid, location: this.location }).then(res => {
          if (res.data) { // 调用后端方法，修改job属性，返回后更新对应的修改字段
            this.job.mbl = res.data.mbl
            this.job.express = res.data.express
            this.job.version = res.data.version
            this.pm.fillView()
          }
        })
      }
    },
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
      if (obj.key === 'designationAgent' && StrUtils.isEmpty(this.job.uuid)) {
        this.checkCredit()
      }
      this.job.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    cargoTerminalOperationChange(p) {
      this.job.cargoTerminalOperation = p.value
      if (!this.job.cargoTerminalOperation) {
        this.job.estimatedDeliveryDate = null
      }
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.job.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.operateType, this.job.fba)
    },
    checkCredit() {
      canCreateByCreditInfoDetail(this.job).then(async res => {
        if (res.data > 0) {
          const msg = {
            dangerouslyUseHTMLString: true,
            message: await JobUtils.checkDateAndAmountExceeded(res.data),
            type: 'warning',
            duration: 5000
          }
          this.$message.warning(msg)
          this.job.designationAgent = 0
        }
      })
    },
    onWoodOrNotWoodChagne(newValue) {
      this.job.wood = newValue.value
      JobUtils.onWoodOrNotWoodChagne(this.job)
    },
    onHazardousGoodsOptionChagne(newValue) {
      this.job.hazardousGoodsOption = newValue.value
      JobUtils.onHazardousGoodsOptionChagne(this.job)
    },
    async onShow(row, isRefresh) {
      if (!row.uuid) {
        row.booking = true
      }
      if (!isRefresh) {
        return
      }
      this.salesCanSeeBookingAgent = Number(this.config.get('SalesCanSeeBookingAgent')) === 1
      await this.pm.init()
      row.atdChanged = false
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.job = row
      this.oldMbl = this.job.mbl
      this.airUlds = this.job.airUld || []
      this.oldMark = this.job.mark || ''
      this.oldCargoEnglishName = this.job.cargoEnglishName || ''
      // 自定义变量初始化
      this.salesList = []
      this.salesPrompt = ''
      this.hasTask = false
      this.selectedRowIndex = -1
      this.selectMawbDialog.btnName = this.$t('SeaExport.PleaseSelect')
      if (!this.job.lclSlaves) {
        await new AirExportJob(this.job).getLclSlaves()
      }
      this.rowData = this.job.lclSlaves
      // handling information
      if (this.job.handlingInformation) {
        this.job.handlingInformationCode = this.job.handlingInformation
        await JobUtils.getHandlingInformationName(this.job)
      }
      this.pm.fillView()
      JobUtils.setSailingDay(this.job)

      // fba
      if (this.job.fba) {
        this.fbaJob = this.job.uuid ? this.job.fbaJob : new FbaJob().fillDefaultValue().getData()
      }
      this.setSecondaryCustomJobTypeFunc()
      this.setCustomJobTypeFunc()

      if (this.action === 'add') {
        this.job.serviceProduct = AirExportConstants.RETAIL_SALES.code
      }
      if (this.action === 'copy' && !this.job.serviceProduct) {
        this.job.serviceProduct = AirExportConstants.RETAIL_SALES.code
      }
      JobUtils.getReceiptCharges(this.job)
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.JOB_UUID = this.job.uuid
      params.category = 'AEBOOKING'
      params.ctx = new AirExportJob(this.job)
      return params
    },
    endTabHandler() {
      this.pm.fillModel()
    },
    async getSubmitData() {
      this.pm.fillModel()
      await this.validateForm()
      if (!this.job.uuid) {
        if (Number(this.config.get('syncSignDateBl')) === 1) {
          this.cargoDoc.signDateBL = this.job.atd
        } else {
          this.cargoDoc.signDateBL = this.job.etd
        }
        const entityDefValUtil = new EntityDefaultValueUtil(this.$store.getters.currentOfficeId, this)
        if (!entityDefValUtil.defaultValues) {
          await entityDefValUtil.initEntityDefaultValue()
        }
        if (entityDefValUtil.cargoDoc) {
          for (let i = 1; i < 8; i++) {
            this.cargoDoc['notifyLine' + i] = entityDefValUtil.cargoDoc['aeMawbNotifyLine' + i]
          }
        }
      }
      if (this.job.handlingInformation) {
        this.job.handlingInformation = this.job.handlingInformationCode // 将code保存到数据库
      }
      // fba业务
      const fbaJob = this.isFba ? this.fbaJob : null
      return {
        job: { ...this.job },
        airUld: this.job.airUld,
        delAirUldUuids: this.job.delAirUldUuids,
        unitLoadDevices: this.job.unitLoadDevices, // this.form.containers.filter(p => p.isDirty === true), // 实际件毛体 更改影响装箱数据未标记isDirty，后续根据需要再处理
        delUnitLoadDeviceUuids: this.job.delUnitLoadDeviceUuids, // 删除的箱子uuid
        delUnitLoadDeviceUsageUuids: this.job.delUnitLoadDeviceUsageUuids, // 删除的装箱uuid
        airCargoDoc: [this.cargoDoc],
        fbaJob
      }
    },
    async validateForm() {
      const form = this.job
      await JobUtils.checkCustomerBranchScope(form, 'masterBasicTab')
      if (!form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeNull'), 'masterBasicTab')
      }
      if (!form.loadingPortCode) {
        throw new TabError(this.$t('Message.PortOfLoadingPortCannotBeNull'), 'masterBasicTab')
      }
      if (!form.destinationPortCode) {
        throw new TabError(this.$t('Message.PortOfDestinationCannotBeNull'), 'masterBasicTab')
      }
      if ((form.bookingTerm === BookingTerm.DB_BOOKING_TYPE.code || Number(this.config.get('AEAllowInputMBL')) === 1) &&
        form.mbl && !AirExportUtils.validateMAWBNumIgnoreZeroOrThree(form.mbl) && !this.job.express) {
        throw new TabError(this.$t('queryJob.TheIsIllegalPleaseEnter'), 'masterBasicTab')
      }
      if (!form.opDepartment) {
        throw new TabError(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'masterBasicTab')
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
        throw new TabError(this.$t('queryJob.PleaseTheDesignatedShippingAgent'), 'masterBasicTab')
      }
      if (form.destinationAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.DestinationAgent'), form.destinationAgent, 'masterBasicTab', 'englishName')
      }
      if (form.bookingAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.BookingAgent'), form.bookingAgent, 'masterBasicTab')
      }
      if (form.carrierId > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.AirlineCompany'), form.carrierId, 'masterBasicTab')
      }
      if (form.cargoSource === 'NC' && form.designationAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent, 'masterBasicTab')
      }
      if (form.sales > 0 && (!form.salesDepartment || form.salesDepartment === 0)) {
        throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'masterBasicTab')
      }

      // 空运头程 保存校验
      if (this.isFba && this.fbaJob) {
        if (!this.fbaJob.preWarehousingTime) {
          throw new TabError(this.$t('AirExport.EstimatedTimeCannotBeEmpty'), 'basicTab')
        }
        if (!this.fbaJob.warehouseCode) {
          throw new TabError(this.$t('AirExport.DestinationCannotBeEmpty'), 'basicTab')
        }
      }

      if (UnitLoadDeviceUtil.checkNoDuplationSeaEQ(form)) {
        throw new TabError(this.$t('SeaExport.RepeatUldType'), 'masterBasicTab')
      }
      const airInput = UnitLoadDeviceUtil.checkInput(form)
      if (airInput) {
        throw new TabError(airInput, 'masterBasicTab')
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'masterBasicTab')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'masterBasicTab')
      }
    },
    selectedMAWBHandler(data = null) {
      this.selectMawbDialog.visible = false
      if (data) {
        this.selectedMAWB = data
        if (!this.job.uuid) {
          this.hasTask = true
          this.job.mbl = data.mawbNo
        } else {
          this.pm.changeMAWB()
        }
      }
    },
    async etdChange(value) {
      const oldValue = this.job.etd
      this.job.etd = value
      if (Number(this.config.get('syncSignDateBl')) === 0) {
        const cargoDocList = await new AirExportJob(this.job).getAirCargoDoc()
        for (const cargoDoc of cargoDocList) {
          const allow = (cargoDoc.docType === CargoDocConsts.MAWB || cargoDoc.docType === CargoDocConsts.HAWB ||
            cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
            (oldValue && dateCompare(DateUtils.formatStandardDate(cargoDoc.signDateBL), DateUtils.formatStandardDate(oldValue)) === 0))
          if (allow) {
            cargoDoc.signDateBL = this.job.etd
          }
        }
      }
      await ChargeUtils.updateETDFee(this.job, this.job.etd, this.context, true)
      this.job.sailingDay = JobUtils.dateChange(this.job.etd)
      if (this.job.etd) {
        JobUtils.matchRegionWarehouseMappingConfig(this.job, null, false, null, this.context.modifiedData)
      }
    },
    async etaChange(value) {
      this.job.eta = value
      this.job.etaSailingDay = JobUtils.dateChange(this.job.eta)
    },
    async atdChange(value) {
      const oldValue = this.job.atd
      this.job.atd = value
      this.job.atdSailingDay = JobUtils.dateChange(this.job.atd)
      if (Number(this.config.get('syncSignDateBl')) === 1) {
        const cargoDocList = await new AirExportJob(this.job).getAirCargoDoc()
        for (const cargoDoc of cargoDocList) {
          const allow = (cargoDoc.docType === CargoDocConsts.MAWB || cargoDoc.docType === CargoDocConsts.HAWB ||
            cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
            (oldValue && dateCompare(DateUtils.formatStandardDate(cargoDoc.signDateBL), DateUtils.formatStandardDate(oldValue)) === 0))
          if (allow) {
            cargoDoc.signDateBL = this.job.atd
          }
        }
      }
      this.job.atdChanged = true
    },
    async ataChange(value) {
      this.job.ata = value
      this.job.ataSailingDay = JobUtils.dateChange(this.job.ata)
    },
    syncSlaves(field) {
      for (const slave of this.job.lclSlaves) {
        slave[field] = this.job[field]
      }
      this.context.modifiedData.lclSlaves = this.job.lclSlaves
    },
    onExChangeAgentChange(data) {
      this.job.exChangeAgent = data.value
      const operatingJobKeySet = new Set()
      for (const slave of this.job.lclSlaves) {
        if (slave.jobState === 0) {
          slave.exChangeAgent = data.value
          operatingJobKeySet.add(slave.uuid)
        }
      }
      for (const item of this.job.dischargingTrucking) {
        if (operatingJobKeySet.has(item.jobUuid)) {
          item.exChangeAgent = data.value
        }
      }
      this.context.modifiedData.lclSlaves = this.job.lclSlaves
      this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
    },
    async weightContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.job, this.job.weightContract)
      }
      this.pm.weightCubageChangeHandler('weightContract')
    },
    async weightStationChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.job, this.job.weightStation)
      }
      this.pm.weightCubageChangeHandler('weightStation')
    },
    async weightSigningChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.job, this.job.weightSigning)
      }
      this.pm.weightCubageChangeHandler('weightSigning')
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
    },
    async cubageContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.job, this.job.cubageContract)
      }
      this.pm.weightCubageChangeHandler('cubageContract')
    },
    async cubageStationChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.job, this.job.cubageStation)
      }
      this.pm.weightCubageChangeHandler('cubageStation')
    },
    async cubageSigningChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.job, this.job.cubageSigning)
      }
      this.pm.weightCubageChangeHandler('cubageSigning')
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    async weightActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshWeightCharge(this.job, this.job.weightActual)
      }
      this.pm.weightCubageChangeHandler('weightActual')
    },
    async cubageActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshCubageCharge(this.job, this.job.cubageActual)
      }
      this.pm.weightCubageChangeHandler('cubageActual')
    },
    onRowDataChanged(event) {
      // 重置（多选）选中行
      this.selectedRows = []
    },
    // grid多选
    onMultipleSelected(event) {
      this.selectedRows = this.gridApi.getSelectedRows()
    },
    // 编辑选择的拼箱分票
    btnLcLEditClickHandler() {
      if (this.selectedRow) {
        this.$emit('selectJob', this.selectedRow.uuid)
      } else {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
    },
    setDimensionsTitle(value) {
      let dimensions = ''
      if (value) {
        dimensions = this.$t('CargoMsg.Cargo_Size') + '：\n'
        value = value.replace(/[,，/Xx;；]/g, match => ({
          ',': '\n',
          '，': '\n',
          ';': '\n',
          '；': '\n',
          'X': '*',
          'x': '*',
          '/': '*'
        })[match])
        dimensions += value
      }
      return dimensions
    },
    // 加入小票回调函数
    toAddTicket() {
      this.selectWindowHandler(this.ticketDialog.value)
      this.ticketDialog.visible = false
    },
    // 移除小票
    async detachSubJobHandler() {
      const job = this.job
      if (!job || !job.lclSlaves) return
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        throw new ErrorTip(this.$t('Message.PleaseSelectSubBills'))
      }
      const jobKeys = Array.from(selectedRows, p => p.uuid)
      await checkJobForShared(jobKeys).then(res => {
        if (res.data) {
          this.$message.warning(res.data + this.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
        } else {
          this.doRemoveHandler(job, selectedRows)
        }
      })
    },
    doRemoveHandler(job, selectedRows) {
      if (job.lclSlaves.length === selectedRows.length) {
        this.detachCloseHandler()
      } else {
        this.detachSelectedHandler(selectedRows)
      }
    },
    // 新增小票按钮点击事件
    newSubJobHandler() {
      this.ticketDialog.value = 1
      this.ticketDialog.visible = true
    },
    // 新增小票回调函数
    async selectWindowHandler(value) {
      const lclJob = await new AirExportJob(this.job).batchCloneLcLJob()
      lclJob.lclMasterUuid = this.job.uuid
      lclJob.lclMaster = this.job
      lclJob.lclNumber = value
      // CARGO-21274 空运订舱基本主票新增小票的页面，开航日期要和主票要保持一致。
      // const today = new Date()
      // lclJob.etd = DateUtils.customFormat(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, today.getHours(), today.getMinutes()), 'YYYY-MM-DD HH:mm')
      this.$emit('addLcl', lclJob)
    },
    // 编辑小票
    editSubJobHandler() {
      if (this.selectedRow) {
        this.$emit('selectJob', this.selectedRow.uuid)
      } else {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
    },
    // 加入小票
    attachSubJobHandler() {
      this.queryAeLclDialog.visible = true
    },
    // 加入小票回调函数
    async attachSubJobCallBackHandler(slaveJobs) {
      const job = this.job
      let lclSlaves = job.lclSlaves
      if (!lclSlaves) {
        job.lclSlaves = lclSlaves = []
      }
      if (slaveJobs && slaveJobs.length > 0) {
        const keys = []
        for (const slaveJob of slaveJobs) {
          keys.push(slaveJob.uuid)
        }
        await batchAddJob(keys, job.uuid, this.location).then(async res => {
          if (res.data) {
            lclSlaves.push(...res.data)
            AirExportUtils.updateActualQWCByAllSubJob(job)
            this.$emit('addSlavedJob', res.data)
            this.$message.success(this.$t('queryJob.JoinTheTicketSuccessfully'))
            if (job && job.masterFlag) {
              await JobUtils.checkJobMAWBOtherCharge(job)
            }
            // 重新设置货物尺寸
            this.pm.setCargoSize()
            this.$nextTick(() => {
              JobUtils.checkMasterShare(this.job.uuid)
            })
          }
        })
      }
    },
    // 删除小票第一种方式：主票下只有一个小票，此时删除小票，主票也要删除
    detachCloseHandler() {
      this.$confirm(this.$t('queryJob.ThereSplitTicketTheTicket'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        detch({ jobKey: this.selectedRow.uuid, location: this.location }).then(res => {
          this.$message.success(this.$t('queryJob.TheTicketHasBeenRemoved'))
          this.$emit('goBack', this.job)
          if (this.job && this.job.masterFlag) {
            JobUtils.checkJobMAWBOtherCharge(this.job)
          }
        })
      }).catch(() => { })
    },
    // 除小票第二种方式：主票下有多个小票，且不全部删除
    detachSelectedHandler(selectedRows) {
      let pass = true
      for (const job of selectedRows) {
        if (job.hasSharedCharge) {
          this.$message.warning('当前小票有分摊费用,不能分离!')
          pass = false
          return
        }
      }
      if (!pass) return
      this.$confirm(this.$t('queryJob.AreRemoveThisSubTicket'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.removedSubJobKeys = []
        this.removedSubJobs = []
        this.removeMbls = []
        for (const job of selectedRows) {
          if (job.mbl) {
            this.removeMbls.push(job.mbl)
          }
          this.removedSubJobKeys.push(job.uuid)
          this.removedSubJobs.push(job)
        }
        if (this.removedSubJobKeys.length > 0) {
          const rowData = this.rowData
          for (let i = 0; i < rowData.length; i++) {
            let index = -1
            for (const item of selectedRows) {
              if (rowData[i] === item.uuid) {
                index = i
                break
              }
            }
            if (index > -1) {
              rowData.splice(index, 1)
            }
          }
          this.gridApi.setRowData(rowData)
          this.selectedRowIndex = -1
          this.gridApi.clearFocusedCell()
          AirExportUtils.updateActualQWCByAllSubJob(this.job)
          unbindingNew({ 'lclKeys': this.removedSubJobKeys, 'mblList': this.removeMbls, 'masterKey': this.job.uuid, 'location': this.location }).then(async res => {
            if (res.data) {
              await JobUtils.checkJobMAWBOtherCharge(this.job)
              this.$emit('removeJobFromMaster', this.removedSubJobKeys)
              // 重新设置货物尺寸
              this.pm.setCargoSize()
              this.removedSubJobs = null
              this.removedSubJobKeys = null
              this.$message.success('移除小票成功！')
            }
          })
        }
      }).catch(() => { })
    },
    // 中转信息回调函数
    transitPortEnterHandler() {
      if (this.cargoDoc.state < 2) {
        new AirCargoDoc(this.cargoDoc).copyTransitPortInfo(this.cargoDoc, this.job)
      }
    },
    // 主单号改变
    mblChangeHandler(text) {
      if (!text || text.length === 0 || text.length === 11) {
        this.pm.checkButtonSate()
      }
    },
    async mblCheckHandler(flg = false) {
      if (flg) {
        await this.mblChangeCallback()
      }
      const mblPrefix = this.$refs.mawbNoInput.prefix.trim()
      if (mblPrefix) {
        const airline = await this.getPartnerAirline(this.job.carrierId)
        const mawbprefix = airline.mawbprefix.trim()
        if (mawbprefix && mawbprefix !== mblPrefix) {
          this.$message.warning(this.$t('queryJob.EnteredXNotMatchAirlinePrefix', [mblPrefix]))
        }
        this.mblChange()
      }
    },
    mblChangeCallback() {
      const mblPrefix = this.$refs.mawbNoInput.prefix.trim()
      if (mblPrefix) {
        const company = JobUtils.getAirLineCompanyByMblPrefixAndOfficeId(mblPrefix, this.$store.getters.currentOfficeId)
        if (company) {
          this.pm.carrierChangeHandler(company.cmpIdx)
        }
      }
    },
    mblChange() {
      if (this.job.mbl === this.oldMbl) {
        return
      }
      this.oldMbl = this.job.mbl
      JobUtils.mblChange(this.job, 'mbl', this)
    },
    // 获取合作伙伴航空公司信息
    async getPartnerAirline(cmpIdx) {
      const airline = { cmpIdx, airlineCode: '', mawbprefix: '' }
      const cmp = Company.getCompanyByIdSync(cmpIdx)
      if (cmp) {
        await getAirlineList({ companyUuid: cmp.uuid }).then(res => {
          if (res.data.list.length > 0) {
            Object.assign(airline, res.data.list[0])
          }
        })
      }
      return airline
    },
    async airlineCompanyCheckHandler(carrierId) {
      if (carrierId > 0) {
        await this.voyageFlightCheckHandler()
        setTimeout(() => {
          this.mblCheckHandler(false)
        }, 100)
      }
    },
    async voyageFlightCheckHandler() {
      if (this.job.voyageFlight) {
        this.job.voyageFlight = this.job.voyageFlight.trim().toUpperCase()
        const voyageFlight = this.job.voyageFlight
        const airline = await this.getPartnerAirline(this.job.carrierId)
        const airlineCode = airline.airlineCode.trim()
        if (airlineCode && airlineCode !== voyageFlight.substring(0, 2)) {
          this.$message.warning(this.$t('queryJob.EnteredXNotMatchAirlineCode', [voyageFlight]))
        }
      }
    },
    closeAdvanceText() {
      this.showMarkOrCargoEnglishNameDialog = false
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    },
    onCargoTypeChagne(data) {
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
    },
    cargoSouceChange(data) {
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
    }
  }
}
</script>

<style scoped lang="scss">
  .el-form-item-group fieldset{
    min-height: 500px;
    width: 350px;
  }
  .red-border {
    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner,
    /deep/ .cargo-rich-textarea{
      border: 1px solid red !important;
    }
  }
</style>
